<template>
  <div class="edit-org-name-box">
    <header-back
      :title="$route.query.comname ? editOrgTit : createOrgTit"
      @back="resetHandler"
    />
    <cube-form
      :model="model"
      @validate="validateHandler"
      @submit.prevent="submitHandler"
      @reset="resetHandler"
    >
      <div class="pro-name-count">
        <cube-form-item :field="fields[0]" />
        <em>{{ model.comname ? (20-model.comname.length) : 20 }}</em>
      </div>
      <div class="form-btn-box">
        <cube-button
          :light="true"
          type="reset"
        >
          {{ $t('message["896"]') }}
        </cube-button>
        <cube-button
          type="submit"
          :primary="true"
        >
          {{ $t('message["915"]') }}
        </cube-button>
      </div>
    </cube-form>
  </div>
</template>
<script>
import HeaderBack from '@/components/mobile/HeaderBack'
import { mapActions } from 'vuex'
export default {
  components: {
    HeaderBack
  },
  data () {
    return {
      validity: {},
      valid: undefined,
      model: {
        comname: this.$route.query.comname
      },
      options: {
        scrollToInvalidField: true,
        layout: 'fresh' // classic fresh
      },
      fields: [
        {
          type: 'input',
          modelKey: 'comname',
          label: '',
          props: {
            placeholder: this.$t('message["843"]'),
            maxlength: 20
          },
          rules: {
            required: true
          }
        }
      ]
    }
  },
  computed: {
    createOrgTit () {
      return this.$t('message["129"]')
    },
    editOrgTit () {
      return this.$t('message["1402"]')
    }
  },
  mounted () {
  },
  methods: {
    ...mapActions('organization/org', ['ajaxEditOrg', 'ajaxCreateOrg']),
    async submitHandler (e) {
      let chain = null
      let obj = {}
      if (this.$route.query.comname) {
        chain = await this.ajaxEditOrg()
        obj = Object.assign(this.model, { cid: this.$route.query.cid })
      } else {
        chain = await this.ajaxCreateOrg()
        obj = Object.assign({}, this.model)
      }
      chain.params(obj)
        .onSuccess(raw => {
          this.$router.push({ name: 'OrgIndex', query: { page: 1 } })
        })
        .onNetSuccess((res) => {
          const toast = this.$createToast({
            time: 2000,
            txt: res.data.message || res.data.payload[0].message,
            type: 'txt'
          })
          toast.show()
        })
        .config({ tip: false })
        .fetch()
    },
    validateHandler (result) {
      this.validity = result.validity
      this.valid = result.valid
    },
    resetHandler () {
      this.$router.push({ name: 'OrgIndex', query: { page: 1 } })
    }
  }
}
</script>
<style lang="scss" scoped>
.pro-name-count {
    position: relative;
    em {
      position: absolute;
      font-style: normal;
      right: 10px;
      top: 15px;
      color: #999;
    }
  }
  .edit-org-name-box::v-deep {
    .cube-form-item {
      line-height: 56px;
      min-height: 56px;
    }
  }
</style>
